/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/fire-and-flower-shelf-talker-post-card-content/fire-and-flower-shelf-talker-post-card-content.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=fire-and-flower-shelf-talker-post-card-content.component.css.map */
